module.exports = __webpack_public_path__ + "pcsg/img/custome.6dbecb89.png";